// extracted by mini-css-extract-plugin
export default {"body":"Loader_body__GQ0fS","loaderbody":"Loader_loaderbody__1wzuE","loader":"Loader_loader__+lRPl","spin":"Loader_spin__E4RJ0"};